// src/components/notifications/NotificationsHeader.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  IconButton,
  Tooltip,
  Badge,
} from '@mui/material';
import {
  Notifications as NotificationsIcon,
  Add as AddIcon,
  FilterList as FilterIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PermissionGate from '../../auth/components/PermissionGate';
import PageHeader from '../../../components/common/PageHeader';

export default function NotificationsHeader({
  onRefresh,
  onToggleFilters,
  loading = false,
  activeFiltersCount = 0,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateToCreate = () => {
    navigate('/notifications/create');
  };

  return (
    <PageHeader
      icon={NotificationsIcon}
      title={t('notifications:header.title')}
      subtitle={t('notifications:header.subtitle')}
      actions={<>
        <Tooltip title={t('notifications:header.refresh')}>
          <IconButton onClick={onRefresh} disabled={loading}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={t('notifications:header.filters')}>
          <IconButton onClick={onToggleFilters}>
            <Badge badgeContent={activeFiltersCount || null} color="primary">
              <FilterIcon />
            </Badge>
          </IconButton>
        </Tooltip>
        <PermissionGate scope="notification:create">
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleNavigateToCreate}
          >
            {t('notifications:create_notification')}
          </Button>
        </PermissionGate>
      </>}
    />
  );
}